let DefaultConfig = {
    name: 'Lenguage predefinido',
    keywords: {
        K_PROCESS: ['Algoritmo'],
        K_END_PROCESS: ['FinAlgoritmo'],
        K_DEFINE: ['Definir'],
        K_AS: ['Como'],
        K_FOR: ['Para'],
        K_TO: ['Hasta'],
        K_DO: ['Hacer'],
        K_END_FOR: ['FinPara'],
        K_IF: ['Si'],
        K_THEN: ['Entonces'],
        K_ELSE: ['SiNo'],
        K_END_IF: ['FinSi'],
        K_ABS: ['ABS'],
        K_SQRT: ['RC'],
        K_WHILE: ['Mientras'],
        K_END_WHILE: ['FinMientras'],
        K_REPEAT: ['Repetir'],
        K_UNTIL: ['Hasta Que'],
        K_STEP: ['Con Paso'],
        K_DIMENSION: ['Dimension'],
        K_SUB_PROCESS: ['Procedimiento'],
        K_END_SUB_PROCESS: ['FinProcedimiento'],
        K_BY: ['Por'],
        K_VALUE: ['Valor'],
        K_REFERENCE: ['Referencia'],
        K_FUNCTION: ['Funcion'],
        K_END_FUNCTION: ['FinFuncion'],
        K_RETURN: ['Retorna'],
        K_WITHOUT_JUMP: ['Sin Saltar'],
        K_WAIT: ['Esperar'],
        K_SELECT: ['Segun'],
        K_OTHERWISE: ['De Otro Modo'],
        K_END_SELECT: ['FinSegun'],
        K_READ: ['Leer'],
        K_WRITE: ['Escribir'],
        K_CLEAR_SCREEN: ['Borrar Pantalla'],
        K_KEY: ['Tecla'],
        K_MOD: ['MOD']
    },
    structure: {
    },
    messages: {
    }
}

export default DefaultConfig



// WEBPACK FOOTER //
// ./src/Core/Language/DefaultConfig.js